import { createUseStyles } from 'react-jss'
import classNames from 'classnames'
import RevealFadeIn from '@/components/RevealFadeIn'
import RevealText from '@/components/RevealText'
import style from './style'

const useStyles = createUseStyles(style)

const ProductOverview = ({
  title,
  text,
  align,
  visible,
  background,
}) => {
  const classes = useStyles()

  return (
    <div
      className={classNames({
        [classes.root]: true,
        [classes.rootBackground]: background && visible,
        [classes.rootBackgroundRight]: background && align === 'right',
        [classes.rootBackgroundLeft]: background && align === 'left',
      })}
    >
      <div className={classes.overview}>
        <div
          className={classNames({
            [classes.wrapperTitle]: true,
            [classes.wrapperTitleRight]: align === 'right',
            [classes.wrapperTitleLeft]: align === 'left',
          })}
        >
          <RevealText
            tag="h2"
            value={title}
            visible={visible}
            enterDuration={1}
            exitDuration={0.8}
            enterDelay={1}
            exitDelay={0.2}
            lineHeight={1.1}
            once={false}
          />
          <RevealFadeIn
            visible={visible}
            className={classes.text}
            enterDuration={0.8}
            exitDuration={0.6}
            enterDelay={1.2}
          >
            <div dangerouslySetInnerHTML={{ __html: text }} />
          </RevealFadeIn>
        </div>
      </div>
    </div>
  )
}

ProductOverview.defaultProps = {
  align: 'right',
}

export default ProductOverview
